import React from 'react'
import { Tooltip, Button } from 'antd'
import { FileSearchOutlined } from '@ant-design/icons'
import parse from 'html-react-parser'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useAnnotationManager } from './useAnnotationManager'
/**
 * Renders a data point value with HTML parsing
 */
const DataPointValue = ({ rendered_value }) => {
  return <>{parse(rendered_value)}</>
}

/**
 * A specialized version of DataPoint for use in ResultView that supports highlighting
 * in PDF documents. This keeps the highlighting logic separate from ReviewDatapoints.
 *
 * When the reggoraReviewPdfAnnotation flag is disabled, this always uses text search.
 */
export function HighlightableDataPoint(props) {
  const {
    name,
    rendered_value,
    field_id,
    comparableNumber,
    highlightedFieldIds,
    onHighlight,
    onSearch,
  } = props

  const flags = useFlags()
  const { clearAnnotationHighlight } = useAnnotationManager()
  // Extract Sales Comparable number if present
  const salesComparableMatch = name?.match(/Sales Comparables #(\d+)/i)
  const salesComparableNumber = salesComparableMatch ? parseInt(salesComparableMatch[1], 10) : null

  // First check if highlighting is enabled AND this is a field that has parsing data
  const isHighlightable = field_id && highlightedFieldIds?.has(field_id)

  const onClickDatapointSearch = () => {
    if (isHighlightable) {
      // Use field-based navigation with highlighting
      onHighlight(field_id, getComparableNumberToUse(flags, comparableNumber, salesComparableNumber))
    } else {
      if (flags?.enableAnnotationScrolling) {
      // Clear any existing annotation highlight before performing text search
        clearAnnotationHighlight()
      }
      // Always fall back to text search
      onSearch(rendered_value)
    }
  }

  return (
    <span>
      {`${name}: `}
      {!flags?.enableAnnotationScrolling && rendered_value && (
        <>
          {<DataPointValue rendered_value={rendered_value} />}
          <Tooltip title="Find">
            <Button
              className='mx-1'
              shape='circle'
              onClick={onClickDatapointSearch}
              icon={<FileSearchOutlined />}
            />
          </Tooltip>
        </>
      )}
      {flags?.enableAnnotationScrolling && (
        <>
          {rendered_value ? <DataPointValue rendered_value={rendered_value} /> : <i>No value</i>}
          <Tooltip title="Find">
            <Button
              className='mx-1'
              shape='circle'
              onClick={onClickDatapointSearch}
              icon={<FileSearchOutlined />}
            />
          </Tooltip>
        </>
      )}
    </span>
  )
}

function getComparableNumberToUse(flags, comparableNumber, salesComparableNumber) {
  if (flags?.enableAnnotationScrolling) {
    return comparableNumber || salesComparableNumber
  }

  return salesComparableNumber
}
